import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Toggle } from "src/UI/Toggle";

interface ToggleSectionProps {
  question: string;
  description?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  noLabel: string;
  yesLabel: string;
  children?: React.ReactNode;
  disabled?: boolean;
}

const ToggleSection: React.FC<ToggleSectionProps> = ({
  question,
  description,
  checked,
  onChange,
  noLabel,
  yesLabel,
  children,
  disabled = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            color: theme.palette.text.primary,
          }}
        >
          {question}
        </Typography>
        <Toggle
          noLabel={noLabel}
          yesLabel={yesLabel}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
      </Box>
      {description && (
        <Typography
          sx={{
            fontSize: "14px",
            color: theme.palette.text.primary,
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default ToggleSection;
